import type { CrremPathwayScale } from "features/crrem-pathway-chart/model/types";

import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { CrremSettings } from "../model/types";

import { EnergyAnalysisSettingsModal } from "./EnergyAnalysisSettingsModal";

type EnergyAnalysisSettingsActionsProps = {
  disabled?: boolean;
  hideCorrectionSelection?: boolean;
  hideMetricSelection?: boolean;
  onSave: (settings: CrremSettings) => void;
  onScaleChange: (scale: CrremPathwayScale) => void;
  scale: CrremPathwayScale;
  settings?: CrremSettings;
};

export const EnergyAnalysisSettingsActions = ({
  disabled,
  hideCorrectionSelection,
  hideMetricSelection,
  onSave,
  onScaleChange,
  scale,
  settings,
}: EnergyAnalysisSettingsActionsProps) => {
  const { t } = useTranslation();
  const [settingsOpen, setSettingsOpen] = useState(false);
  return (
    <Stack className="shrink-0 gap-2">
      {settings ? (
        <Button
          disabled={disabled}
          isActive={settingsOpen}
          onClick={() => setSettingsOpen(true)}
          size="sm"
          startIconName="Gears"
          variant="tertiary"
        >
          {t("BuildingProfile.energyAnalysis.settings.title")}
        </Button>
      ) : null}
      {settings ? (
        <EnergyAnalysisSettingsModal
          disabled={disabled}
          hideCorrectionSelection={hideCorrectionSelection}
          hideMetricSelection={hideMetricSelection}
          modalOpen={settingsOpen}
          onSave={onSave}
          onScaleChange={onScaleChange}
          scale={scale}
          setModalOpen={setSettingsOpen}
          settings={settings}
        />
      ) : null}
    </Stack>
  );
};
